import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

import { AppFacade } from 'ish-core/facades/app.facade';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';

const AUTH_PATH_PREFIXES = ['/login', '/register', '/account/request-access', '/forgotPassword'];

/**
 * CUSTOMIZATION: Presidio auth shell — hide store header on login/register; use compact legal footer.
 * Quote-cart conflict modal (FR13.7.5) is hosted in the template via AppModule import.
 */
@Component({
  selector: 'ish-root',
  templateUrl: './app.component.presidio.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent implements OnInit {
  wrapperClasses$: Observable<string[]>;
  deviceType$: Observable<DeviceType>;
  authShell$: Observable<boolean>;

  constructor(private appFacade: AppFacade, private router: Router) {}

  ngOnInit() {
    this.deviceType$ = this.appFacade.deviceType$;
    this.wrapperClasses$ = this.appFacade.customAppWrapperClasses$;
    this.authShell$ = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(e => this.isAuthUrl(e.urlAfterRedirects)),
      startWith(this.isAuthUrl(this.router.url))
    );
  }

  private isAuthUrl(url: string): boolean {
    const path = url.split('?')[0];
    return AUTH_PATH_PREFIXES.some(prefix => path === prefix || path.startsWith(`${prefix}/`));
  }
}
